var FcTextInputModule = /** @class */ (function () {
    function FcTextInputModule() {
    }
    return FcTextInputModule;
}());
export { FcTextInputModule };
